import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import { Card, CardBody, CardHeader, Container } from "reactstrap";

import Header from "../../../components/Headers/Header";
import { ISelectedFilters } from "../../../types";
import Filter from "../Components/Filter/Filter";
import CustomTable from "../../../components/Tables/CustomTable";
import HeaderWithDownload from "../../../components/HeaderWithDownload";

export default function MonthlyStudentPerformance() {
  const session = useSelector((state: any) => state.user.session);

  const [selectedFilters, setSelectedFilters] = useState<ISelectedFilters>();

  const [selectedFilterForReport, setSelectedFilterForReport] =
    useState<ISelectedFilters>();

  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <HeaderWithDownload
              title="Student Monthly
                Performance"
              reportType="performance"
              selectedFilters={selectedFilterForReport}
            />

            <div className="pt-2">
              <Filter
                hasDistrictFilter
                hasBlockFilter
                hasSchoolFilter
                hasGradeFilter
                onSearch={(value) => {
                  setSelectedFilters(value);
                }}
                onClear={() => {
                  setSelectedFilters(undefined);
                }}
                onFilterChange={(value) =>
                  setSelectedFilterForReport({
                    ...value,
                    date: {
                      start_date: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                      end_date: moment().add(1, "d").format("YYYY-MM-DD"),
                    },
                  })
                }
              />
            </div>
          </CardHeader>

          <CardBody>
            <CustomTable
              url={`custom/stats_admin/student/performance?grade_id=${
                selectedFilters?.gradeId || -1
              }&student_id=-1&grade_section_id=-1&district=${
                selectedFilters?.districtId || -1
              }&block=${selectedFilters?.blockId || -1}&school=${
                selectedFilters?.schoolId || -1
              }&start_date=${moment()
                .subtract(30, "days")
                .format("YYYY-MM-DD")}&end_date=${moment()
                .add(1, "d")
                .format("YYYY-MM-DD")}&limit=${10}&session=${session?.id}`}
              column={[
                { key: "srn_no", label: "SRN No." },
                { key: "first_name", label: "First name" },
                { key: "last_name", label: "Last name" },
                { key: "grade", label: "Grade" },
                { key: "section", label: "Section" },
                { key: "school", label: "School" },
                { key: "block", label: "Block" },
                { key: "district", label: "District" },
                { key: "points", label: "Points" },
                { key: "total_no_of_questions", label: "Total Questions" },
                { key: "performance_score", label: "Performance (%)" },
              ]}
              tableTitle={""}
              searchBox={false}
              itemsLimit={10}
              customFunction={() => {}}
              customColumns={[
                {
                  heading: "Attempted Right/Wrong",
                  renderer: (each: any) => {
                    return (
                      <span>
                        {`${each?.attempted_right}/${each?.attempted_wrong}` ||
                          0}
                      </span>
                    );
                  },
                },
              ]}
            />
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
